import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { MxNavigationBarActions } from "../store/ducks/components/NavigationBar/navigationBar";

/**
 * @typedef {Object} Options
 * @property {any[]} [deps=[]]
 *
 * @typedef {() => import("../store/ducks/components/NavigationBar/navigationBar").OnMinimizarOptions | void} Callback Callback passado para o botão de minimizar, retornando um obj de opções do on Minimizar
 */

/**
 * Hook para atualizar o onMinimizar da NavigationBar
 * @param {Callback} cb 
 * @param {Options} [options={}]

 */
export function useUpdateOnMinimizar(cb, options) {
    const { deps } = Object.assign({}, { deps: [cb] }, options);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(MxNavigationBarActions.onMinimizar(cb));
        return () => {
            dispatch(MxNavigationBarActions.resetOnMinimizar());
        };
    }, deps);
}
